import React, { Component } from 'react';
import { adminservice } from '../../services/admin.service';
import Loader from '../../_helpers/Loader';
import { historypush } from '../../_helpers/utilities';
import DataTable from 'react-data-table-component';
import UploadQuestionBankModel from './Component/UploadQuestionBankModel';
import DeleteQuestionBankModel from './Component/DeleteQuestionBankModel';
import { UncontrolledTooltip } from 'reactstrap';

const validFileFormats = ["pdf", "xls", "xlsx","doc","docx"];

const DatatableStyle={
    table: {
        style: {
            //minHeight: '720px', // override the row height
            maxHeight: '720px',
        },
    },
}
class adminquestionbank extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading:false,
            selectedCategory:'1',
            category:[],
            showSelectedCategoryError:false,
            selectedSubCategory:'1',
            subCategory:[],
            showSelectedSubCategoryError:false,
            documentList:[],
            fileInputKey: this.generateRandomString(),
            documentFile: null,
            errorFile: false,
            folderName:'Questionbank',
            selectedEditCategory:'1',
            selectedEditSubCategory:'1',
            showSelectedEditCategoryError:false,
            selectedQuestionId:'0',
            showSelectedEditSubCategoryError:false,
            showEditmodel:false,
            showDeleteModel:false,
            selectQuestionIdToDelete:'0',
            showSucessMessage:false,
            showQAforMEO:false,
            meoQuestionList:[],
         };
    }

    componentDidMount=async() =>{
        const Role = localStorage.getItem("RoleId");

        if(Role == 1 || Role == 4){
            this.getDropDownValues();
            this.getQuestionBankValues();
        }else{
            historypush('/login');
        }
    }

    generateRandomString = () => {
        return Math.random().toString(36);
    };

    /* <summary>
    date: 28-06-2022
    Name: VD
    description: This is used to get the dropdown values to bind to the category and subcategory
    <summary>*/ 
    getDropDownValues=async()=>{
        try{
            this.setState({
                isLoading:true,
            })
    
            var response = await adminservice.GetCategoryAndSubCategoryList();
            if(response.status === 200){
                this.setState({
                    category:response.data,
                    unfilteredCategory:response.data,
                },async()=>{
                    this.bindSubCategory(1);
                })
            }else if(response.status===401){
                localStorage.clear();
                historypush('/login');
            }

            this.setState({
                isLoading:false,
            })
        }catch(e){
            return "";
        }
    }

    bindSubCategory=(categoryId)=>{
        const{category, }=this.state;

        var filteredSubCategory = category.filter((item)=>item.categoryID === categoryId);

        this.setState({
            subCategory:filteredSubCategory[0].subCategoryModels,
        })

    }

    /* <summary>
    date: 29-06-2022
    Name: VD
    description: This is used to get the list of all the Question bank that have been uploaded
    <summary>*/ 
    getQuestionBankValues=async()=>{
        try{
            this.setState({
                isLoading:false,
            })
            
            var response = await adminservice.GetQuestionBankList();
            if(response.status === 200){
                this.setState({
                    documentList:response.data,
                })
            }
            
        }catch(e){
            return "";
        }
    }

    documentHeader = [
        {
          name: <th >Sr.No</th>,
          selector: (row) => row.srno,
          center: true,
        },
        {
          name: <th className="question-doc">Document Names</th>,
          selector: (row) =><div key={row.questionBankID}>
            <span className="view" id={'UncontrolledTooltipStatus' + row.questionBankID} > {row.documentName}</span> 
            <UncontrolledTooltip placement="top" target={'UncontrolledTooltipStatus' + row.questionBankID}>
            {row.documentName}
            </UncontrolledTooltip>
            </div>,
          left: true,
        },
        {
          name: <th className="question-doc">Category</th>,
          selector: (row) => row.categoryName,
          center: true,
        },
        {
          name: <th className="question-doc">Sub Category</th>,
          selector: (row) => row.subCategoryName,
          center: true,
        },
        {
          name: <th >View</th>,
          selector: (row) =><a className="view" 
                            onClick={()=>this.openFile(row)} style={{ cursor: "pointer",paddingLeft:'13px'}}>
                                View
                            </a>,
          center: true,
        },
        {
          name: <th >Edit</th>,
          selector: (row) =><td className="download" onClick={()=>this.selectQuestionId(row)} style={{cursor:'pointer'}}><i className="fa fa-pencil-square-o" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal"/></td>,
          center: true,
        },
        {
          name: <th >Delete</th>,
          selector: (row) =><td className="delete" onClick={()=>this.DeleteModel(row)} style={{cursor:'pointer'}}><i className="fa fa-trash" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>,
          center: true,
        },
    ];

    MEOHeader = [
        {
          name: <th >Sr.No</th>,
          selector: (row) => row.srno,
          center: true,
        },
        {
          name: <th className="question-doc">Document Names</th>,
          selector: (row) =><div key={row.questionBankID}>
            {row.documentName}
            </div>,
          left: true,
        },
        {
          name: <th >View</th>,
          selector: (row) =><a className="view" 
                            onClick={()=>this.openFile(row)} style={{ cursor: "pointer",paddingLeft:'13px'}}>
                                View
                            </a>,
          center: true,
        },
        {
          name: <th >Delete</th>,
          selector: (row) =><td className="delete" onClick={()=>this.DeleteModel(row)} style={{cursor:'pointer'}}><i className="fa fa-trash" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>,
          center: true,
        },
    ];

    openFile=(row)=>{
        let filePath=row.documentFilePath;
        if(filePath !== ""){
          window.open(filePath, "_blank");
        }
    }

    selectQuestionId=(row)=>{
        this.setState({
            showEditmodel:true,
            selectedQuestionId:row.questionBankID,
            selectedEditCategory:row.categoryID,
            selectedEditSubCategory:row.subCategoryID,
            
        })
    }

    DeleteModel=(row)=>{
        // if(this.state.showQAforMEO){
        //     this.setState({
        //         showDeleteModel:true,
        //         selectQuestionIdToDelete:row.questionbankMeoid
        //     })
        // }
        // else{
            this.setState({
                showDeleteModel:true,
                selectQuestionIdToDelete:row.questionBankID,
            })
        //}
    }
    
    /* <summary>
    date: 29-06-2022
    Name: VD
    description: This is used to save the question bank File that has been uploaded in a certain category
    <summary>*/ 
    saveQuestionBank=async()=>{
        try{
            this.setState({isLoading:true});
                const{
                    selectedCategory,
                    selectedSubCategory,
                    documentFile,
                    folderName,
                    selectedQuestionId,
                    showQAforMEO,
                }=this.state;
                
                let data = new FormData();
                data.append("file", documentFile);
                data.append("folderName",folderName);
                data.append("category", selectedCategory);
                data.append("subcategory", selectedSubCategory);
                data.append("questionId",selectedQuestionId);
                data.append("showQAforMEO",showQAforMEO);
                
                var response = await adminservice.SaveQuestionBank(data);
                if(response.status === 200){
                    this.setState({
                        showSucessMessage:true,
                        fileInputKey: this.generateRandomString(),
                        documentFile: null
                    })
                    setTimeout(()=>{
                        this.closeMessage()
                    },3000)
                    if(showQAforMEO){
                        this.GetQuestionBankListMEO();
                    }else{
                        this.getQuestionBankValues();
                    }
                }

            this.setState({isLoading:false});
        }catch(e){
            return "";
        }
    }

    closeMessage=()=>{
        this.setState({showSucessMessage:false});
    }

    validate=()=>{
        try{
            const{
                selectedCategory,
                selectedSubCategory,
                showQAforMEO,
            }=this.state;
            let val = true;
            
            if(!showQAforMEO){
                if(selectedCategory === ""){
                    this.setState({
                        showSelectedCategoryError:true,
                    })
                    val=false;
                }
                if(selectedSubCategory === ""){
                    this.setState({
                        showSelectedSubCategoryError:true,
                    })
                    val=false;
                }
            }

            if (this.state.documentFile == null) {
                this.setState({
                  errorFile: true,
                });
                
                val=false;
            }

            if(val === false){
                return val;
            }else{
                this.saveQuestionBank();
            }
        }catch(e){
            return "";
        }
    }

    OnEventChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            showSelectedCategoryError:false,
            showSelectedSubCategoryError:false,

      }
    )}

    onFileChange = (e) => {
        if (!this.isValidFile(e.target.value)) {
          this.setState({
            fileInputKey: this.generateRandomString(),
            documentFile: null,
            errorFile: true,
            assignmentFileList:null,
          });
          return;
        }
    
        let file = e.target.files[0];

        this.setState({
          documentFile: file,
          errorFile: false,
        });
    };

    isValidFile = (value) => {
        //check if value is blank
        if (!value) return false;
    
        //regex to get file extension
        var re = /(?:\.([^.]+))?$/;
    
        //second item in the array will be the extension
        let ext = re.exec(value)[1];
        return validFileFormats.some((x) => x === ext);
    };

    clearEditModel=()=>{
        this.setState({
            selectedEditCategory:'1',
            selectedEditSubCategory:'1',
            showSelectedEditCategoryError:false,
            selectedQuestionId:'0',
            showSelectedEditSubCategoryError:false,
            documentFile: null,
            showEditmodel:false,
            showDeleteModel:false,
        },async()=>{
            if(this.state.showQAforMEO){
                this.GetQuestionBankListMEO();
            }else{
                this.getQuestionBankValues();
            }
        })
    }

    reloadGrid=()=>{
        this.setState({
            showEditmodel:false,
        })
        this.clearEditModel();
        this.getQuestionBankValues();
    }

    goBack=()=>{
        if(this.state.showQAforMEO){
            window.location.reload();
        }else{
            historypush('/admindashboard');
        }
    }

    setQAforMEObool=()=>{
        this.setState({
            showQAforMEO:true,
            errorFile: false,
        })
        this.GetQuestionBankListMEO();
    }

    GetQuestionBankListMEO=async()=>{
        try{
            this.setState({
                isLoading:false,
            })
            var response = await adminservice.GetQuestionBankListMEO();
            if(response.status === 200){
                this.setState({
                    meoQuestionList:response.data,
                })
            }
            this.setState({
                isLoading:false,
            })
        }catch(e){
            return "";
        }
    }

    closeSuccessModel=()=>{
        this.setState({showSucessMessage:false})
    }
    render() {
        const{
            isLoading,
            category,
            selectedCategory,
            subCategory,
            selectedSubCategory,
            documentList,
            showSelectedCategoryError,
            showSelectedSubCategoryError,
            fileInputKey,
            errorFile,
            showEditmodel,
            selectedQuestionId,
            showDeleteModel,
            selectQuestionIdToDelete,
            selectedEditCategory,
            selectedEditSubCategory,
            showSucessMessage,
            showQAforMEO,
            meoQuestionList,
        }=this.state;
        return (
            <div className="member-body">
            {isLoading && <Loader />}
            <div className="about">
            <div className="container">
                <div className="row">
                <div className="col-md-6"><h2 className="heading">Add New Question Bank</h2></div>
                <div className="col-md-6 question-mob">
                    {!showQAforMEO?
                    <button  onClick={()=>this.setQAforMEObool()} type="button" className="btn Submit-btn" style={{backgroundColor: '#4B7BB0', padding: '7px 25px', float: 'right'}}>
                    <a style={{textDecoration: 'none', color: 'white'}}>Questions and Answers for MEO Exams</a>
                    </button>	
                    :""}
                </div>
                </div>
                <div style={{backgroundColor: 'white', padding: '25px', marginBottom: '20px'}}>
                <div className="col-lg-7 col-md-9 col-12" style={{overflowX: 'auto'}}> 
                    <table className="table">
                    <tbody>
                        {showQAforMEO?"":
                        <tr>
                        <td className="about-filter" style={{width: '35%'}}><h4 style={{fontSize: '22px'}}>Select Category:</h4></td>
                        <td>
                            <select 
                                className="quest-bank-form form-select form-select-lg mb-2" 
                                aria-label=".form-select-lg example"
                                value={selectedCategory}
                                name="selectedCategory"
                                onChange={this.OnEventChange.bind(this)}
                                >
                                {category.map((item)=>{
                                    return(
                                        <option value={item.categoryID}>{item.categoryName}</option>
                                    )
                                })}
                            
                            </select>
                            {showSelectedCategoryError && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                            >
                                Please select a category
                            </small>
                            )}
                        </td>
                        </tr>
                        }
                        {showQAforMEO?"":
                        <tr>
                        <td className="about-filter"><h4 style={{fontSize: '22px'}}>Select Sub Category:</h4></td>
                        <td>
                            <select 
                                className="quest-bank-form form-select form-select-lg mb-2" 
                                aria-label=".form-select-lg example"
                                value={selectedSubCategory}
                                name="selectedSubCategory"
                                onChange={this.OnEventChange.bind(this)}
                            >
                            {subCategory.map((item)=>{
                                    return(
                                        <option value={item.subCategoryID}>{item.subCategoryName}</option>
                                    )
                                })}
                            
                            </select>
                            {showSelectedSubCategoryError && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                            >
                                Please select a sub category
                            </small>
                            )}
                        </td>
                        </tr>
                        }
                        <tr>
                        <td className="about-filter"><h4 style={{fontSize: '22px'}}>Attach Document:</h4></td>
                        <td>
                            <input 
                                accept=".pdf,.xlsx, .xls,.doc,.docx" 
                                type="file" 
                                id="myfile" 
                                name="documentFile"
                                onChange={this.onFileChange}
                                key={fileInputKey || ""}
                            /><br />
                            <p>(.pdf, .doc and .xls only)</p>
                            {errorFile && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                                >
                                Please select a file
                                </small>
                            )}
                            {showSucessMessage && (
                            <div id="thank_you" className="alert alert-success alert-dismissible" style={{ fontSize: '16px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                <button type="button" className="btn-close" onClick={()=>this.closeSuccessModel()} />
                                File Uploaded.
                            </div>
                        )}
                        </td>
                        </tr>
                        
                        <tr>
                        <td />
                        <td><button 
                                type="button" 
                                className="btn btn-save-question"
                                onClick={this.validate}
                                >Save</button></td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                </div>
                <div className="table-responsive">
                {showQAforMEO?
                //     <table className="table question-table">
                //     <thead className="quest-table-head">
                //       <tr>
                //         <th className="sr-no">Sr No</th>
                //         <th className="question-doc">Document Names</th>
                //         <th className="sr-no">View</th>
                //         <th className="sr-no">Delete</th>
                //       </tr>
                //     </thead>
                //     <tbody className="quest-table-body">
                //       <tr className="blue-color">
                //         <td className="sr-no">1</td>
                //         <td>Document 1</td>
                //         <td className="view"><a href="#">View</a></td>
                //         <td className="delete" onClick={()=>this.DeleteModel()} style={{cursor:'pointer'}}><i className="fa fa-trash" style={{fontSize:'20px'}} data-bs-toggle="modal" data-bs-target="#myModal1" /></td>
                //       </tr>
                      
                //     </tbody>
                //   </table>
                        <DataTable
                        columns={this.MEOHeader}
                        data={meoQuestionList}
                        noHeader={true}
                        fixedHeader={true}
                        fixedHeaderScrollHeight="450px"
                        pagination
                        customStyles={DatatableStyle}
                    />
                :
                    <DataTable
                        columns={this.documentHeader}
                        data={documentList}
                        noHeader={true}
                        fixedHeader={true}
                        fixedHeaderScrollHeight="450px"
                        pagination
                        customStyles={DatatableStyle}
                    />
                }
                <button type="button" className="question-button btn btn-white" onClick={()=>this.goBack()}>Back</button>
                </div>
            </div>
            </div>
            {showEditmodel && (
                <UploadQuestionBankModel 
                    category={category}
                    subCategory={subCategory}
                    clearEditModel={this.clearEditModel}
                    selectedQuestionId={selectedQuestionId}
                    selectedEditCategory={selectedEditCategory}
                    selectedEditSubCategory={selectedEditSubCategory}
                    getQuestionBankValues={this.getQuestionBankValues}
                />
            )}
            {showDeleteModel && (
                <DeleteQuestionBankModel 
                    clearEditModel={this.clearEditModel}
                    selectQuestionIdToDelete={selectQuestionIdToDelete}
                    getQuestionBankValues={this.getQuestionBankValues}
                    showQAforMEO={showQAforMEO}
                />
            )}
        </div>
        );
    }
}

export default adminquestionbank;